import DefaultTemplatePanel from "../../layout/content-templates/default/DefaultTemplatePanel.tsx";
import MarketplaceOptions from "../../common/product/marketplace/MarketplaceOptions.tsx";
import { PrintVariant } from "../../../../common/api/decimal/methods/product.ts";

export default function StoreMarketplacePanel({
  vbid,
  variant,
  onRequestClose,
}: {
  vbid: string;
  variant: PrintVariant;
  onRequestClose: () => void;
}) {
  return (
    <DefaultTemplatePanel onRequestClose={onRequestClose}>
      <MarketplaceOptions
        vbid={vbid}
        variant={variant}
        onRequestClose={onRequestClose}
      />
    </DefaultTemplatePanel>
  );
}
